import { Button, Group } from "@mantine/core";
import { useGoogleLogin } from "@react-oauth/google";
import {
  AuthFacebookIcon,
  AuthGoogleIcon,
  AuthLinkedInIcon,
} from "../../shared/svg";
import axiosInstance from "../../utils/axios";
import FacebookLogin from "react-facebook-login";

import useAuthStore from "../../store/useAuthStore";
import { useNavigate } from "react-router";
import { FC } from "react";
import { setProfileLanguage } from "../../api/profileApi";
import { useTranslation } from "react-i18next";
import useProfileStore from "../../store/useProfileStore";

interface SocialButtonsProps {
  setMaxStep: (num: number) => void;
  setIsSocialLoading: (bol: boolean) => void;
}

export const SocialButtons: FC<SocialButtonsProps> = ({
  setMaxStep,
  setIsSocialLoading,
}) => {
  const navigate = useNavigate();
  const { googleAuth, setIsLoggedIn } = useAuthStore();
  const { i18n } = useTranslation();
  const { getProfileLanguage } = useProfileStore();

  const clientId = "YOUR_LINKEDIN_CLIENT_ID";
  const redirectUri = process.env.REACT_APP_LINKEDIN_REDIRECT_URL;

  const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
    redirectUri!
  )}&scope=r_liteprofile%20r_emailaddress`;

  const responseFacebook = (response: any) => {
    console.log(response);
    // Тепер у response буде доступна вся інформація про користувача,
    // наприклад: userId, name, email, accessToken тощо.
    const { accessToken, userID } = response;

    // Ви можете передавати отриманий accessToken на бекенд для подальшої обробки,
    // наприклад для отримання даних користувача або реєстрації в системі.
    if (accessToken) {
      // Викликаємо API бекенду для логіну
      // axios.post('/api/facebook-login', { accessToken });
    }
  };

  const login = useGoogleLogin({
    flow: "auth-code",
    scope: "openid email profile",
    onSuccess: async (response) => {
      try {
        setIsSocialLoading(true);
        const { code } = response;
        const tokenResponse = await axiosInstance.post(
          "https://oauth2.googleapis.com/token",
          {
            code,
            client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
            client_secret: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_SECRET,
            redirect_uri: window.location.origin,
            grant_type: "authorization_code",
          }
        );

        const { access_token } = tokenResponse.data;

        const data = await googleAuth(access_token);

        if (data.status === "login") {
          setIsLoggedIn(true);
          navigate("/");
          setIsSocialLoading(false);
        }

        if (data.status === "register") {
          await setProfileLanguage(i18n.language);
          getProfileLanguage();
          setMaxStep(2);
          navigate("/auth/upload-cv");
          setIsSocialLoading(false);
        }
        setIsSocialLoading(false);
      } catch (err) {
        setIsSocialLoading(false);
        console.error("Google login error:", err);
      }
    },
    onError: () => {
      setIsSocialLoading(false);
      console.error("Failed to login with Google");
    },
  });

  return (
    <Group justify="center" grow>
      {/* <Button
        variant="default"
        size="md"
        // onClick={() => (window.location.href = linkedInAuthUrl)}
      >
        <AuthLinkedInIcon />
      </Button> */}

      <Button variant="default" size="md" onClick={() => login()}>
        <AuthGoogleIcon />
      </Button>

      {/* <Button variant="default" size="md">
        <FacebookLogin
          appId="YOUR_FACEBOOK_APP_ID"
          autoLoad={false}
          fields="name,email,picture"
          callback={responseFacebook}
          icon={<AuthFacebookIcon />}
          textButton=""
          cssClass="my-facebook-button-class"
        />
        <AuthFacebookIcon />
      </Button> */}
    </Group>
  );
};
